const prepareParamsForUrl = (value, name, showRange = true) => {
    let paramsString = '?';
    const paramsAsArray = window.location.search
        .substring(1)
        .split('&')
        .map(item => {
            const obj = {};
            const splittedItem = item.split('=');
            if (!splittedItem[1]) {
                return obj;
            }
            obj[`${splittedItem[0]}`] = splittedItem[1]
            return obj;
        });

    let params = {};

    paramsAsArray.forEach(param => {
        const rangeParams = {
            range_min: 0,
            range_max: 3000,
        }

        if (showRange) {
            params = {
                ...rangeParams,
                ...params,
            }
        }

        params = {
            ...params,
            ...param,
        }
    });

    params[name] = value;

    for (let param in params) {
        paramsString += `${param}=${encodeURIComponent(params[param])}&`;
    }

    return paramsString.substring(0, paramsString.length - 1);
}

export default { prepareParamsForUrl };
